// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type QuestionMark20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const QuestionMark20: FC<QuestionMark20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M8.917 12.5c0-1 .1-1.746.302-2.24.201-.493.621-1.017 1.26-1.572.597-.514 1-.928 1.209-1.24.208-.313.312-.663.312-1.052 0-.528-.188-.962-.563-1.302-.374-.34-.854-.51-1.437-.51-.514 0-.965.16-1.354.479-.39.319-.667.756-.834 1.312l-2-.833a4.234 4.234 0 0 1 1.594-2.209A4.33 4.33 0 0 1 10 2.5c1.236 0 2.243.358 3.02 1.073.779.715 1.168 1.635 1.168 2.76 0 .584-.129 1.115-.386 1.594-.257.48-.719 1.031-1.385 1.656-.57.528-.92.948-1.052 1.26-.132.313-.205.865-.22 1.657H8.918ZM10 17c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 0 1 8.5 15.5c0-.417.146-.77.438-1.063A1.446 1.446 0 0 1 10 14c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062 0 .417-.146.77-.438 1.063A1.446 1.446 0 0 1 10 17Z" />
        </svg>
    );
};

export default QuestionMark20;
